import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';
import { poAttentionFlags, type AttentionSource } from './poStatus';

// Compact table-cell rendering of poAttentionFlags; the drawer shows the same
// flags in full.
export function PoAttentionMarker({ purchaseOrder }: { purchaseOrder: AttentionSource }) {
    const flags = poAttentionFlags(purchaseOrder);
    if (flags.length === 0) return null;
    const hasDanger = flags.some((flag) => flag.tone === 'danger');
    return (
        <Tooltip content={flags.map((flag) => flag.label).join('\n')} side="top">
            <span className="inline-flex shrink-0">
                <ExclamationTriangleIcon
                    className={`h-3.5 w-3.5 ${hasDanger ? 'text-rose-600' : 'text-amber-600'}`}
                />
            </span>
        </Tooltip>
    );
}
